"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getErrorMessageFromPattern = exports.formatVisitIdPatternOption = exports.visitIdPatternOptions = void 0;
var visitIdPatternsEnum = (function () {
    // * Default pattern
    var patterns = { '^[0-9]{1,20}$': { option: 'Inconnue', errorMessage: '1 à 20 chiffres attendus' } };
    // * Exact length pattern
    for (var i = 5; i <= 20; ++i) {
        patterns["^[0-9]{".concat(i, "}$")] = { option: "".concat(i, " chiffres"), errorMessage: "".concat(i, " chiffres attendus") };
    }
    return patterns;
})();
exports.visitIdPatternOptions = Object.keys(visitIdPatternsEnum);
var formatVisitIdPatternOption = function (pattern) { var _a, _b; return (_b = (_a = visitIdPatternsEnum[pattern]) === null || _a === void 0 ? void 0 : _a.option) !== null && _b !== void 0 ? _b : 'Inconnue'; };
exports.formatVisitIdPatternOption = formatVisitIdPatternOption;
var getErrorMessageFromPattern = function (pattern) { var _a; return (_a = visitIdPatternsEnum[pattern]) === null || _a === void 0 ? void 0 : _a.errorMessage; };
exports.getErrorMessageFromPattern = getErrorMessageFromPattern;
//# sourceMappingURL=pattern.js.map